import { useState, useCallback } from "react";

export const useActionMenu = ({
  record,
  onMapToBooking,
  onCreateNewBooking,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = useCallback((event) => {
    if (event) event.stopPropagation();
    setAnchorEl(event?.currentTarget || null);
  }, []);

  const handleClose = useCallback((event) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
  }, []);

  const handleMap = useCallback(
    (event) => {
      handleClose(event);
      if (onMapToBooking) onMapToBooking(record);
    },
    [handleClose, onMapToBooking, record]
  );

  const handleCreate = useCallback(
    (event) => {
      handleClose(event);
      if (onCreateNewBooking) onCreateNewBooking(record);
    },
    [handleClose, onCreateNewBooking, record]
  );

  return {
    anchorEl,
    isOpen: Boolean(anchorEl),
    handleClick,
    handleClose,
    handleMap,
    handleCreate,
  };
};
